import BreadCrumb from "../screens/Common/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/layout/admin-dashboard";
import UserAdd from "../screens/Users1/UserAdd";

const breadCrumbData = [
  { link: "/users-view", name: "Users" },
  { link: "/createusers", name: "Add Users" }
];

const Users = () => (
  <>
    <LayoutContainer>
      <BreadCrumb data={breadCrumbData} />
      <UserAdd />
    </LayoutContainer>
  </>
);

export default Users;
